<template>
  <button class="btn text-btn link-main" @click="toggleShowTable">
    {{ $t('PUBLISHING.DETAIL.PRODUCTS.MODES.SHOW_COMPARISON') }}
    <Icon icon="chevron" :class="{ open: showTable }" />
  </button>

  <transition name="expand">
    <div v-if="showTable">
      <div class="badges"></div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th :class="compositionModeSettings.SMART.bgClass">
              <h4>
                <Icon :icon="compositionModeSettings.SMART.icon" />
                {{ $t('PUBLISHING.DETAIL.PRODUCTS.MODES.SMART') }}
              </h4>
              <p>
                {{ $t('PUBLISHING.DETAIL.PRODUCTS.MODES.SMART_DESCRIPTION') }}
              </p>
            </th>
            <th :class="compositionModeSettings.ADVANCED.bgClass">
              <h4>
                <Icon :icon="compositionModeSettings.ADVANCED.icon" />
                {{ $t('PUBLISHING.DETAIL.PRODUCTS.MODES.ADVANCED') }}
              </h4>
              <p>
                {{
                  $t('PUBLISHING.DETAIL.PRODUCTS.MODES.ADVANCED_DESCRIPTION')
                }}
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in TABLE_DATA" :key="row.translation">
            <td>
              {{ $t(row.translation) }}
            </td>
            <td>
              <ProductSettingsModeComparisonIcon :supported="row.smart" />
            </td>
            <td>
              <ProductSettingsModeComparisonIcon :supported="row.advanced" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { compositionModeSettings } from 'commons/composition/compositionHelper';
import ProductSettingsModeComparisonIcon from 'src/app/partnerarea/publishing/detail/productSettings/ProductSettingsModeComparisonIcon.vue';
import { ref } from 'vue';

const showTable = ref(false);

const toggleShowTable = () => {
  showTable.value = !showTable.value;
};

const TABLE_DATA: Record<
  string,
  { translation: string; smart: boolean; advanced: boolean }
> = {
  AUTO_PRODUCT_SELECTION: {
    translation:
      'PUBLISHING.DETAIL.PRODUCTS.MODES.COMPARISON.AUTO_PRODUCT_SELECTION',
    smart: true,
    advanced: false,
  },
  CUSTOM_PRODUCT_SELECTION: {
    translation:
      'PUBLISHING.DETAIL.PRODUCTS.MODES.COMPARISON.CUSTOM_PRODUCT_SELECTION',
    smart: false,
    advanced: true,
  },
  PRODUCT_ADDITION: {
    translation: 'PUBLISHING.DETAIL.PRODUCTS.MODES.COMPARISON.PRODUCT_ADDITION',
    smart: true,
    advanced: false,
  },
  AUTO_PLACEMENT_AND_COLOR: {
    translation:
      'PUBLISHING.DETAIL.PRODUCTS.MODES.COMPARISON.AUTO_PLACEMENT_AND_COLOR',
    smart: true,
    advanced: false,
  },
  CUSTOM_PLACEMENT_AND_COLOR: {
    translation:
      'PUBLISHING.DETAIL.PRODUCTS.MODES.COMPARISON.CUSTOM_PLACEMENT_AND_COLOR',
    smart: false,
    advanced: true,
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

button {
  display: flex;
  align-items: center;

  svg {
    margin-left: 8px;
    transform: rotate(90deg);

    &.open {
      transform: rotate(270deg);
    }
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-out;
  max-height: 100%;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

table {
  max-width: 930px;
  text-align: center;

  th {
    border: 1px solid $grey20;
    border-collapse: collapse;
    text-align: center;
    vertical-align: top;
    padding: 16px 32px;

    &:first-of-type {
      border: none;
    }

    svg {
      height: 24px;
      width: 24px;
    }

    h4 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin: 0;
      vertical-align: baseline;
    }

    p {
      margin: 8px 0 0;
      font-weight: normal;
    }
  }

  td {
    width: 25%;
    padding: 8px 24px;
    border: 1px solid $grey20;
    border-collapse: collapse;

    &:first-of-type {
      width: 40%;
      text-align: left;
    }
  }
}
</style>
